import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import FooterLogo from "../../assets/images/footerlogo.png";
import { LogOutAction } from "../../redux/actions/user-action-types";
import Header from "./header";
import Sidebar from "./sidebar";

const DashboardLayout = ({ children }) => {
	const dispatch = useDispatch();


	const [isSidebarOpen, setSidebarOpen] = React.useState(false);

	const toggleSidebar = async (e) => {
		e.preventDefault();

		document.getElementById("body").className = `${
			isSidebarOpen ? "" : "sidebar-toggled"
		}`;

		setSidebarOpen(!isSidebarOpen);
	};

	return (
		<div>
			<div id="wrapper" className="d-flex flex-column " style={{height:'100vh'}}>
				<Header toggleSidebar={toggleSidebar} className={isSidebarOpen} />
				<div className="d-flex" style={{ overflow: 'hidden', height: '100%'}}>
					<Sidebar className={isSidebarOpen} />
					<div
						id="content-wrapper"
						className="d-flex flex-column   bg-scheduler"
						style={{}}
					>
						<div id="content"
						style={{ height: '100%', overflowX: 'auto'}}>{children}</div>

					</div>
				</div>
				<footer className="sticky-footer py-2 bg-dgery">
					<div className="container-fluid my-auto ">
						<footer className="main-footer">
							<div className="footer-element">
								<img src={FooterLogo} alt="footer logo" className="pr-2" /> ©
								{new Date().getFullYear()} all rights reserved{" "}
							</div>
						</footer>
					</div>
				</footer>
			</div>
			<a className="scroll-to-top rounded" href="#page-top">
				<i className="fa fa-angle-up" />
			</a>
			<div
				className="modal fade modalwidth580"
				id="logoutModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								Ready to Leave?
							</h5>
							<button
								className="close"
								type="button"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							Select "Logout" below if you are ready to end your current
							session.
						</div>
						<div className="modal-footer">
							<button
								className="btn btn-secondary"
								type="button"
								data-dismiss="modal"
							>
								Cancel
							</button>
							<button
								className="btn btn-primary"
								data-dismiss="modal"
								onClick={async (e) => {
									dispatch(LogOutAction({ requestLoginAgain: false }));
								}}
							>
								Logout
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DashboardLayout;
